// // The Vue build version to load with the `import` command
// // (runtime-only or standalone) has been set in webpack.base.conf with an alias.

import 'babel-polyfill'
import Es6Promise from 'es6-promise'
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'

import './utils'
import * as filters from './utils/filters'
import './style'
import './style/theme/element-variables.scss'
import lang from 'element-ui/lib/locale/lang/en'
import locale from 'element-ui/lib/locale'
import 'ele-calendar/dist/vue-calendar.css'

// import './utils/permission'

import container from '@/components/container';
import header from '@/components/header';
import main from '@/components/main';
import footer from '@/components/footer';
import table from '@/components/table';
import notificationChart from '@/components/notification-chart';
import login from '@/components/login';
import successBox from '@/components/successBox';
import readFail from '@/components/readFail';
import account from '@/components/account';
import forgotPass from '@/components/forgotPassword';

// element-ui component
import {
  Button,
  Select,
  Option,
  Row,
  Col,
  Tabs,
  TabPane,
  Form,
  FormItem,
  DatePicker,
  Loading,
  Input,
  Table,
  TableColumn,
  Checkbox,
  CheckboxButton,
  Dialog,
  Scrollbar,
  Notification,
  Tooltip,
  Carousel,
  CarouselItem
} from 'element-ui';
Vue.use(Button)
Vue.use(Select)
Vue.use(Option)
Vue.use(Row)
Vue.use(Col)
Vue.use(Tabs)
Vue.use(TabPane)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Input)
Vue.use(Checkbox)
Vue.use(CheckboxButton)
Vue.use(Dialog)
Vue.use(Scrollbar)
Vue.use(Tooltip)
Vue.use(Carousel)
Vue.use(CarouselItem)
Vue.use(DatePicker)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Loading)
locale.use(lang)
Vue.prototype.$notify = Notification;
Vue.prototype.$notifyChart = notificationChart;

// 自定义组件
Vue.use(container)
Vue.use(header)
Vue.use(main)
Vue.use(footer)
Vue.use(table)
Vue.use(login)
Vue.use(successBox)
Vue.use(readFail)
Vue.use(account)
Vue.use(forgotPass)

// 添加全局过滤器
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

// eslint-disable-next-line
Es6Promise.polyfill()

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js